import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IAgent } from "../agentModel";

export const getAllAgent = createAsyncThunk("Agent/FindAllAgent", async () => {
  try {
    const response = await axiosApiInstance.post(
      `${API_URL}/Agent/FindAllAgent`,
      {
        Agent: "",
      }
    );
    return response.data?.Data;
  } catch (error: any) {
    // ErrorToast(error?.response?.data?.Details || "Something went wrong");
    console.error("Error Fetching Agent:", error);
    return Promise.reject({
      message: error?.response?.data?.Details || "Something went wrong",
    });
  }
});

export const getAllActiveAgent = createAsyncThunk(
  "Agent/FindAllActiveAgent",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Agent/FindAllActiveAgent`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Agent:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createAgent = createAsyncThunk(
  "Agent/InsertAgent",
  async (AgentData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Agent/InsertAgent`,
        AgentData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Agent:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateAgent = createAsyncThunk(
  "Agent/UpdateAgent",
  async (AgentData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Agent/UpdateAgent`,
        AgentData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Agent:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAgentByID = createAsyncThunk(
  "Agent/FindByIDAgent",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Agent/FindByIDAgent`,
        { agent_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        agent_guid: result.agent_guid,
        agent_name: result.agent_name,
        mobile: result.mobile,
        email: result.email,
        address: result.address,
        contact_person: result.contact_person,
        isactive: result.isactive === true ? 1 : 2,
      } as IAgent;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Agent:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const agentActiveInactive = createAsyncThunk(
  "Agent/ActiveInActvieAgent",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Agent/ActiveInActvieAgent`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Agent:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteAgent = createAsyncThunk(
  "Agent/DeleteAgent",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Agent/DeleteAgent`,
        { agent_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Agent:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
